import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// 普通用户版：仅保留登录后基础功能
const routes = [
  {
    path: "/",
    name: "welcome",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/register.vue"),
  },
  {
    path: "/retrieve-password",
    name: "RetrievePassword",
    component: () => import("../views/retrievePassword.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home.vue"),
  },
  {
    path: "/role-config",
    name: "RoleConfig",
    component: () => import("../views/roleConfig.vue"),
  },
  {
    path: "/voice-print",
    name: "VoicePrint",
    component: () => import("../views/VoicePrint.vue"),
    meta: { requiresAuth: true, title: "我的声纹" },
  },
  {
    path: "/voice-print-management",
    name: "VoicePrintManagement",
    component: () => import("../views/VoicePrintManagement.vue"),
    meta: { requiresAuth: true, title: "声纹管理" },
  },
  {
    path: "/device-management",
    name: "DeviceManagement",
    component: () => import("../views/DeviceManagement.vue"),
  },
  {
    path: "/voice-clone-management",
    name: "VoiceCloneManagement",
    component: () => import("../views/VoiceCloneManagement.vue"),
    meta: { requiresAuth: true, title: "音色克隆管理" },
  },
  {
    path: "/custom-voice-apply-management",
    name: "CustomVoiceApplyManagement",
    component: () => import("../views/CustomVoiceApplyManagement.vue"),
    meta: { requiresAuth: true, title: "定制音色申请" },
  },
  {
    path: "/voice-management",
    name: "VoiceManagement",
    component: () => import("../views/VoiceManagement.vue"),
    meta: { requiresAuth: true, title: "我的音色" },
  },
  {
    path: "/knowledge-base-management",
    name: "KnowledgeBaseManagement",
    component: () => import("../views/KnowledgeBaseManagement.vue"),
    meta: { requiresAuth: true, title: "知识库管理" },
  },
  {
    path: "/knowledge-file-upload",
    name: "KnowledgeFileUpload",
    component: () => import("../views/KnowledgeFileUpload.vue"),
    meta: { requiresAuth: true, title: "文档上传管理" },
  },
];

const router = new VueRouter({
  base: process.env.VUE_APP_PUBLIC_PATH || "/",
  routes,
});

// 全局处理重复导航，改为刷新页面
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name === "NavigationDuplicated") {
      window.location.reload();
    } else {
      throw err;
    }
  });
};

// 需要登录才能访问的路由（普通用户版）
const protectedRoutes = [
  "home",
  "RoleConfig",
  "VoicePrint",
  "DeviceManagement",
  "VoiceCloneManagement",
  "CustomVoiceApplyManagement",
  "VoiceManagement",
  "KnowledgeBaseManagement",
  "KnowledgeFileUpload",
];

router.beforeEach((to, from, next) => {
  if (protectedRoutes.includes(to.name)) {
    const token = localStorage.getItem("token");
    if (!token) {
      next({ name: "login", query: { redirect: to.fullPath } });
      return;
    }
  }
  next();
});

export default router;
